var CoordSet = /** @class */ (function () {
    function CoordSet() {
        var _this = this;
        this.getCoordKey = function (coord) {
            return coord.rowId + ":" + coord.columnId;
        };
        this.getCoord = function (key) {
            var parts = key.split(":");
            return {
                rowId: Number(parts[0]),
                columnId: Number(parts[1])
            };
        };
        this.coordSet = new Set();
        this.size = 0;
        this.add = function (coord) {
            _this.coordSet.add(_this.getCoordKey(coord));
            _this.size = _this.coordSet.size;
            return _this;
        };
        this.has = function (coord) {
            return _this.coordSet.has(_this.getCoordKey(coord));
        };
        this["delete"] = function (coord) {
            var success = _this.coordSet["delete"](_this.getCoordKey(coord));
            if (success) {
                _this.size = _this.coordSet.size;
            }
            return success;
        };
        this.values = function () {
            var values = [];
            _this.coordSet.forEach(function (key) {
                values.push(_this.getCoord(key));
            });
            return values;
        };
    }
    return CoordSet;
}());
export { CoordSet };
//# sourceMappingURL=CoordSet.js.map